var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    staticClass: "pt-1",
    attrs: {
      value: _vm.value,
      items: _vm.items,
      label: _vm.label,
      loading: _vm.loading,
      hint: _vm.items.length + " available · leave blank to apply to all",
      "persistent-hint": "",
      outlined: "",
      clearable: "",
      dense: "",
      multiple: "",
      chips: "",
      "small-chips": "",
    },
    on: {
      change: function ($event) {
        return _vm.$emit("input", $event || [])
      },
    },
    scopedSlots: _vm._u([
      {
        key: "prepend-item",
        fn: function () {
          return [
            _c(
              "v-list-item",
              {
                attrs: { ripple: "" },
                on: {
                  mousedown: function ($event) {
                    $event.preventDefault()
                  },
                  click: _vm.toggleSelectAll,
                },
              },
              [
                _c(
                  "v-list-item-action",
                  [
                    _c(
                      "v-icon",
                      { attrs: { color: _vm.value.length ? "primary" : "" } },
                      [_vm._v(_vm._s(_vm.selectAllIcon))]
                    ),
                  ],
                  1
                ),
                _c(
                  "v-list-item-content",
                  [_c("v-list-item-title", [_vm._v("Select all")])],
                  1
                ),
              ],
              1
            ),
            _c("v-divider", { staticClass: "mt-2" }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }